import { BaseAPIModel } from '@weezevent/weezjs-core';

export default class ModerationActions extends BaseAPIModel {
    fields() {
        return {
            name: {},
            id: { primaryKey: true, readOnly: true }
        };
    }

    static listUrl({ organizationId, flowId, transitionId }) {
        if (!transitionId) {
            return `/ticket/organizations/${organizationId}/moderation_flows/${flowId}/transition_actions`;
        }
        return `/ticket/organizations/${organizationId}/moderation_flows/${flowId}/transitions/${transitionId}/transition_actions`;
    }

    toOption() {
        return {
            key: this.id,
            text: this.name,
            value: this.id,
            item: this.object
        };
    }
}
